import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/appData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                  C
                </div>
                <span className="font-heading font-bold text-lg text-background-50">
                  {siteInfo.name}
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed mb-4">
                {siteInfo.description.slice(0, 60)}...
              </p>
              <div className="flex items-center gap-3">
                {['ri-wechat-line', 'ri-weibo-line', 'ri-github-line', 'ri-twitter-x-line'].map((icon) => (
                  <a
                    key={icon}
                    href="#"
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200"
                    rel="nofollow"
                  >
                    <i className={icon}></i>
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">快速链接</h4>
              <ul className="space-y-2.5">
                {[
                  { to: '/', label: '首页' },
                  { to: '/category/all', label: '文章中心' },
                  { to: '/category/tutorial', label: '使用教程' },
                  { to: '/category/update', label: '版本更新' },
                  { to: '/about', label: '关于我们' },
                ].map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">文章分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(1).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.id}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">联系方式</h4>
              <ul className="space-y-2.5">
                <li className="flex items-start gap-2 text-sm text-background-400">
                  <i className="ri-mail-line mt-0.5 text-background-500"></i>
                  <span>support@cpp-official.com</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-background-400">
                  <i className="ri-phone-line mt-0.5 text-background-500"></i>
                  <span>400-888-2777</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-background-400">
                  <i className="ri-map-pin-line mt-0.5 text-background-500"></i>
                  <span>深圳市南山区科技园南路88号CPP大厦</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {currentYear} {siteInfo.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
                服务条款
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
                Cookie政策
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}